// extracted by mini-css-extract-plugin
module.exports = {"link":"RecentPost-module--link--1Hmp8","recentPost":"RecentPost-module--recent-post--2UvNo","date":"RecentPost-module--date--3qatO"};